import { render, staticRenderFns } from "./SiteDialog.vue?vue&type=template&id=08cea1d6&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./SiteDialog.vue?vue&type=script&lang=js&"
export * from "./SiteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cea1d6",
  null
  
)

export default component.exports